module.exports = __webpack_public_path__ + "img/cerrado.7c46f3bb.png";